// pending = 1,
// authorized = 2,
// partially_paid = 3,
// paid = 4,
// partially_refunded = 5,
// refunded = 6,
// voided = 7,
// deliveredInternal = 8

const enumStatus = (id) => {
    switch (id) {
        case 1:
            return "Pendente";
        case 2:
            return "Autorizado";
        case 3:
            return "Parcialmente Pago";
        case 4:
            return "Pago";
        case 5:
            return "Parcialmente Extornado";
        case 6:
            return "Extornado";
        case 7:
            return "Anulado";
        case 8:
            return "Entregue";
        default:
            return id;
    }
};

const getStatus = (status) => {
    switch (status) {
        case "pending":
            return "Pendente";
        case "authorized":
            return "Autorizado";
        case "partially_paid":
            return "Parcialmente Pago";
        case "paid":
            return "Pago";
        case "partially_refunded":
            return "Parcialmente Extornado";
        case "refunded":
            return "Extornado";
        case "voided":
            return "Anulado";
        case "deliveredInternal":
            return "Entregue";
        default:
            return status;
    }
};

function generateSearchURL(params) {
    // 1. Filter out empty, null, or undefined values
    const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([key, value]) => {
            // Keep entries where value is not null, not undefined, and not an empty string
            return value !== null && value !== undefined && value !== "";
        }),
    );

    // 2. Create URLSearchParams object from the filtered object
    const searchParams = new URLSearchParams(filteredParams);

    // 3. Generate the query string
    const queryString = searchParams.toString();

    // Return with a leading '?' if there are parameters, otherwise an empty string
    return queryString ? `?${queryString}` : "";
}

const getPaymentStatus = (status) => {
    switch (status) {
        case "authorized":
            return "Autorizado";
        case "pending":
            return "Pendente";
        case "paid":
            return "Pago";
        default:
            return status;
    }
};

const getDeliveryStatus = (status) => {
    switch (status) {
        case "fulfilled":
            return "Enviado";
        default:
            return status;
    }
};

const formatDateFull = (data) => {
    return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

const formatDate = (data) => {
    return new Date(data).toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

const getFieldName = (value) => {
    // Nome não confere! Nome da mãe não confere! Data de nascimento não confere!
    // CPF digitado não confere! Nome digitado não confere!
    const dict = {
        CPF: "cpf",
        Nome: "fullName",
        "Data de nascimento": "birthdate",
        DataNascimento: "birthdate",
    };
    return dict[value] ?? value;
};

const getProductModel = (metafields) => {
    if (!metafields || metafields.length == 0) return "";
    const findModel = metafields.find((x) => x.key === "Modelo");
    return findModel ? findModel.value : "";
};

const getProductSerie = (metafields) => {
    if (!metafields || metafields.length == 0) return "";
    const findSerie = metafields.find((x) => x.key === "Número de Série");
    return findSerie ? findSerie.value : "";
};

const getProductFabricated = (metafields) => {
    if (!metafields || metafields.length == 0) return "";
    const result = metafields.find((x) => x.key === "Ano de fabricação");
    return result && result.value !== "" ? result.value : "Desconhecido";
};

const formatBirthDate = (value) => {
    const [day, month, year] = value.split("/");
    if (!day || !month || !year) return value;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

const formatMoney = (value) => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value);
};

const getProductStatus = (product) => {
    return product.title.includes("[PAUSADO]")
        ? "PAUSADO"
        : product.title.includes("[VENDIDO]")
          ? "VENDIDO"
          : product.status === "active"
            ? "PUBLICADO"
            : "EM ANÁLISE";
};

document.addEventListener("alpine:init", () => {
    Alpine.store("bankList", {
        data: [
            { id: "508", name: "Avenue Securities Banco de Investimento" },
            { id: "246", name: "Banco ABC Brasil" },
            { id: "075", name: "Banco ABN AMRO Clearing" },
            { id: "299", name: "Banco Afinz" },
            { id: "121", name: "Banco Agibank" },
            { id: "025", name: "Banco Alfa" },
            { id: "065", name: "Banco AndBank Brasil" },
            { id: "213", name: "Banco Arbi" },
            { id: "096", name: "Banco B3" },
            { id: "024", name: "Banco Bandepe" },
            { id: "330", name: "Banco Bari de Investimentos e Financiamentos" },
            { id: "334", name: "Banco Besa" },
            { id: "318", name: "Banco BMG" },
            { id: "250", name: "Banco BMG Consignado" },
            { id: "233", name: "Banco BMG Soluções Financeiras" },
            { id: "752", name: "Banco BNP Paribas Brasil" },
            { id: "107", name: "Banco Bocom BBM" },
            { id: "063", name: "Banco Bradescard" },
            { id: "237", name: "Banco Bradesco" },
            { id: "036", name: "Banco Bradesco BBI" },
            { id: "122", name: "Banco Bradesco BERJ" },
            { id: "394", name: "Banco Bradesco Financiamentos" },
            { id: "378", name: "Banco Brasileiro de Crédito" },
            { id: "218", name: "Banco BS2" },
            { id: "208", name: "Banco BTG Pactual" },
            { id: "413", name: "Banco BV" },
            { id: "336", name: "Banco C6" },
            { id: "626", name: "Banco C6 Consignado" },
            { id: "473", name: "Banco Caixa Geral – Brasil" },
            { id: "040", name: "Banco Cargill" },
            { id: "266", name: "Banco Cédula" },
            { id: "745", name: "Banco Citibank" },
            { id: "241", name: "Banco Clássico" },
            { id: "756", name: "Banco Cooperativo Sicoob" },
            { id: "748", name: "Banco Cooperativo Sicredi" },
            { id: "222", name: "Banco Crédit Agricole Brasil" },
            { id: "069", name: "Banco Crefisa" },
            { id: "368", name: "Banco CSF" },
            { id: "003", name: "Banco da Amazônia" },
            { id: "083", name: "Banco da China Brasil" },
            { id: "707", name: "Banco Daycoval" },
            { id: "300", name: "Banco de la Nación Argentina" },
            { id: "495", name: "Banco de la Provincia de Buenos Aires" },
            { id: "654", name: "Banco Digimais" },
            { id: "335", name: "Banco Digio" },
            { id: "001", name: "Banco do Brasil" },
            { id: "047", name: "Banco do Estado de Sergipe — Banese" },
            { id: "037", name: "Banco do Estado do Pará — Banpará" },
            { id: "041", name: "Banco do Estado do Rio Grande do Sul — Banrisul" },
            { id: "004", name: "Banco do Nordeste do Brasil" },
            { id: "265", name: "Banco Fator" },
            { id: "224", name: "Banco Fibra" },
            { id: "094", name: "Banco Finaxis" },
            { id: "125", name: "Banco Genial" },
            { id: "390", name: "Banco GM" },
            { id: "612", name: "Banco Guanabara" },
            { id: "269", name: "Banco HSBC" },
            { id: "012", name: "Banco Inbursa" },
            { id: "708", name: "Banco Induscred de Investimento" },
            { id: "604", name: "Banco Industrial do Brasil" },
            { id: "077", name: "Banco Inter" },
            { id: "249", name: "Banco Investcred Unibanco" },
            { id: "479", name: "Banco ItauBank" },
            { id: "074", name: "Banco J. Safra" },
            { id: "376", name: "Banco J.P. Morgan" },
            { id: "217", name: "Banco John Deere" },
            { id: "076", name: "Banco KDB do Brasil" },
            { id: "757", name: "Banco KEB Hana do Brasil" },
            { id: "600", name: "Banco Luso Brasileiro" },
            { id: "389", name: "Banco Mercantil do Brasil" },
            { id: "381", name: "Banco Mercedes-Benz do Brasil" },
            { id: "370", name: "Banco Mizuho do Brasil" },
            { id: "066", name: "Banco Morgan Stanley" },
            { id: "456", name: "Banco MUFG Brasil" },
            { id: "415", name: "Banco Nacional" },
            {
                id: "007",
                name: "Banco Nacional de Desenvolvimento Econômico e Social — BNDES",
            },
            { id: "212", name: "Banco Original" },
            { id: "623", name: "Banco Pan" },
            { id: "611", name: "Banco Paulista" },
            { id: "643", name: "Banco Pine" },
            { id: "747", name: "Banco Rabobank International Brasil" },
            { id: "088", name: "Banco Randon" },
            { id: "633", name: "Banco Rendimento" },
            { id: "741", name: "Banco Ribeirão Preto" },
            { id: "120", name: "Banco Rodobens" },
            { id: "422", name: "Banco Safra" },
            { id: "033", name: "Banco Santander Brasil" },
            { id: "743", name: "Banco Semear" },
            { id: "276", name: "Banco Senff" },
            { id: "754", name: "Banco Sistema" },
            { id: "366", name: "Banco Société Générale Brasil" },
            { id: "637", name: "Banco Sofisa" },
            { id: "554", name: "Banco StoneX" },
            { id: "464", name: "Banco Sumitomo Mitsui Brasileiro" },
            { id: "082", name: "Banco Topázio" },
            { id: "387", name: "Banco Toyota do Brasil" },
            { id: "795", name: "Banco Traton Brasil" },
            { id: "095", name: "Banco Travelex" },
            { id: "634", name: "Banco Triângulo" },
            { id: "018", name: "Banco Tricury" },
            { id: "505", name: "Banco UBS Brasil" },
            { id: "393", name: "Banco Volkswagen" },
            { id: "655", name: "Banco Votorantim" },
            { id: "610", name: "Banco VR" },
            { id: "119", name: "Banco Western Union do Brasil" },
            { id: "124", name: "Banco Woori Bank do Brasil" },
            { id: "348", name: "Banco XP" },
            { id: "475", name: "Banco Yamaha Motor do Brasil" },
            { id: "081", name: "BancoSeguro" },
            {
                id: "021",
                name: "Banestes — Banco do Estado do Espírito Santo",
            },
            {
                id: "755",
                name: "Bank of America Merrill Lynch Banco Múltiplo",
            },
            { id: "320", name: "Bank of China Brasil Banco Múltiplo" },
            { id: "496", name: "BBVA Brasil Banco de Investimento" },
            { id: "017", name: "BNY Mellon Banco" },
            { id: "126", name: "BR Partners Banco de Investimento" },
            { id: "128", name: "Braza Bank Banco de Câmbio" },
            { id: "070", name: "BRB — Banco de Brasília" },
            { id: "104", name: "Caixa Econômica Federal" },
            { id: "477", name: "Citibank N.A." },
            { id: "487", name: "Deutsche Bank — Banco Alemão" },
            { id: "144", name: "Ebury Banco de Câmbio" },
            { id: "064", name: "Goldman Sachs do Brasil Banco Múltiplo" },
            { id: "078", name: "Haitong Banco de Investimento do Brasil" },
            { id: "132", name: "ICBC do Brasil Banco Múltiplo" },
            { id: "139", name: "Intesa Sanpaolo Brasil Banco Múltiplo" },
            { id: "143", name: "Intex Bank Banco de Câmbio" },
            { id: "341", name: "Itaú Unibanco" },
            { id: "488", name: "JPMorgan Chase Bank, National Association" },
            { id: "399", name: "Kirton Bank" },
            { id: "323", name: "Mercado Pago" },
            { id: "259", name: "Moneycorp Banco de Câmbio" },
            { id: "753", name: "Novo Banco Continental" },
            { id: "260", name: "Nu Pagamentos — Nubank" },
            { id: "613", name: "Omni Banco" },
            { id: "712", name: "Ouribank" },
            { id: "290", name: "PagSeguro Internet" },
            { id: "254", name: "Paraná Banco" },
            { id: "079", name: "PicPay Bank Banco Múltiplo" },
            { id: "529", name: "Pinbank Brasil" },
            { id: "751", name: "Scotiabank Brasil Banco Múltiplo" },
            { id: "412", name: "Social Bank Banco Múltiplo" },
            { id: "533", name: "SRM Bank" },
            { id: "665", name: "Stark Bank" },
            { id: "014", name: "State Street Brasil Banco Comercial" },
            { id: "129", name: "UBS BB Banco de Investimento" },
        ],
    });
    Alpine.store("headerMenu", {
        show: false,
        open() {
            this.show = !this.show;
            setTimeout(() => {
                this.show = false;
            }, 8000);
        },
    });
    Alpine.store("toast", {
        show: false,
        type: "success",
        title: "Sucesso",
        message: "",
        timeout: null,
        open(type, message, duration = 8000) {
            this.message = message;
            this.type = type;
            this.title =
                type === "success"
                    ? "Sucesso"
                    : type === "warning"
                      ? "Atenção"
                      : "Desculpe";
            this.show = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.show = false;
            }, duration);
        },
        close() {
            this.show = false;
        },
    });
});

const checkCPF = (value) => {
    const cpf = value.replace(/[^\d]+/g, "");

    if (cpf === "") return false;

    if (cpf.length !== 11) return false;

    // Rejeitar CPFs com todos os dígitos iguais
    if (
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999" ||
        cpf === "12345678909"
    ) {
        return false;
    }

    let soma = 0;
    let resto = 0;

    // Verificar o primeiro dígito verificador
    for (let i = 1; i <= 9; i++) {
        soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;

    // Verificar o segundo dígito verificador
    for (let i = 1; i <= 10; i++) {
        soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
};

const reorderItems = (itens) => {
    const OUTROS_PALAVRAS = ["outros", "outras", "outro", "outra"];

    function getTexto(item) {
        return (item.name || item.nome || item.marca || "").toString().trim();
    }

    function isOutros(texto) {
        const t = texto.toLowerCase();
        return OUTROS_PALAVRAS.includes(t);
    }

    return [...itens].sort((a, b) => {
        const textoA = getTexto(a);
        const textoB = getTexto(b);

        const aEhOutros = isOutros(textoA);
        const bEhOutros = isOutros(textoB);

        if (aEhOutros && !bEhOutros) return 1;
        if (!aEhOutros && bEhOutros) return -1;

        return textoA.localeCompare(textoB, "pt-BR", { sensitivity: "base" });
    });
};
